export function getGalleryMethod(type, product) {
	if (!type) return null;
	if (!product) return null;
	if (!product.gallerys) return null;

	let gallery = [];

	for (let i = 0; i < product.gallerys.length; i++) {
		gallery.push(product.gallerys[i].gallery);
	}

	gallery = gallery.filter(function(element) {
		return element.name && element.name == type;
	});

	return gallery.length && gallery[0].categories ? gallery[0].categories : [];
}
